import { defaultRequestHeaders } from "../consts/shared";
import createAxiosInstance from "../utils/axiosInstance";
import Env from "../env/Env";

const request = createAxiosInstance(`${Env.API_BASE}/api/graphs/shared`);

interface CacheStats {
  size: number;
  keys: string[];
  nextExpiry?: string;
  cacheType: string;
}

interface NextSyncInfo {
  nextSync: string;
  timeUntilSync: string;
}

interface CacheStatsResponse {
  cacheStats: CacheStats;
  nextSyncInfo: NextSyncInfo;
  message: string;
  cacheType: string;
  serverTime: string;
}

const cacheAPIsService = {
  getCacheStats: (signal?: AbortSignal): Promise<CacheStatsResponse> => {
    return new Promise((resolve, reject) => {
      request
        .get("/cache-stats", { signal })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  clearCache: (signal?: AbortSignal): Promise<{ message: string }> => {
    return new Promise((resolve, reject) => {
      request
        .post("/cache-clear", {}, { signal })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  deleteCacheByKey: (key: string, signal?: AbortSignal): Promise<{ message: string }> => {
    return new Promise((resolve, reject) => {
      request
        .delete(`/cache-key/${encodeURIComponent(key)}`, { signal })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  clearCacheByDashboard: (dashboard: string, signal?: AbortSignal): Promise<{ message: string; deletedCount: number; dashboard: string }> => {
    return new Promise((resolve, reject) => {
      request
        .post(`/cache-clear-dashboard/${dashboard}`, {}, { signal })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
};

export default cacheAPIsService; 